import React, { useEffect, useState } from 'react'
import { NoAssets } from '../../../../../../RichTextEditor/SuperChargedRte/elements/Element/contentstack/image/Modal/Upload/UploadComponent';

import { getFolders } from '../../request';

import { AssetBreadCrumb, AssetSearch } from '../SelectImage';
import { ListView } from './View/ListView';
import { ThumbnailView } from './View/UploadThumbnailView'


function UploadImage(props) {
  const { editor } = props;
  const [state, setState] = useState({
    assets: [
      { uid: 'new row', new: true }
    ],
    loading: false,
    selectedImage: {},
    itemStatusMap: {},
    displayType: 'List',
    startIndex: 0,
    count: 12,
    stopIndex: 8,
    query: '',
    breadcrumb: [{
      displayName: 'All Assets',
      action: () => {
        setState(currState => ({
          ...currState,
          breadcrumb: currState.breadcrumb.slice(0, 1),
          folderUid: 'cs_root'
        }))
      }
    }],
    folderUid: 'cs_root',
    uploading: false
  });

  useEffect(() => {
    if (!editor.requestProps.apiKey) {
      setState(state => ({
        ...state,
        count: 0,
        loading: false,
        assets: []
      }));
      return;
    }
    fetchOnChange({ skip: 0, limit: 30, startIndex: 0, stopIndex: 30 })
  }, [state.query, state.folderUid]);

  useEffect(() => {
    let instanceItemStatusMapped = [];
    for (let i = 0; i <= 12; i++) {
      instanceItemStatusMapped[i] = props.loading ? 'loading' : 'loaded';
    }
    setState(state => ({ ...state, loading: props.loading, itemStatusMap: { ...state.itemStatusMap, ...instanceItemStatusMapped } }));
  }, [props.loading])

  const fetchOnChange = async ({ sortBy = null, skip, limit, startIndex, stopIndex }) => {
    const instanceItemStatusMapped = {};

    for (let i = startIndex; i <= stopIndex; i++) {
      instanceItemStatusMapped[i] = 'loading';
    }

    setState({
      ...state,
      itemStatusMap: {
        ...instanceItemStatusMapped
      },
      loading: true
    });
    let sort = {
      asc_field: '',
      dsc_field: ''
    };

    if (sortBy) {
      sort[`${sortBy['sortingDirection']}_field`] = sortBy['id'];
    }

    const response = await getFolders({ ...editor.requestProps, limit, 'skipSize': skip, query: state.query, folderUid: state.folderUid, ...sort });


    for (let i = startIndex; i <= stopIndex + 1; i++) {
      instanceItemStatusMapped[i] = 'loaded'
    }

    setState({
      ...state,
      assets: [
        { uid: 'new row', new: true },
        ...response.assets
      ],
      itemStatusMap: {
        ...instanceItemStatusMapped
      },
      startIndex,
      stopIndex,
      loading: false,
      count: response.count,
    });

  }

  const loadMore = async ({ sortBy = null, skip, limit, startIndex, stopIndex }) => {
    if (stopIndex <= state.startIndex) return;
    startIndex = Math.max(state.startIndex, startIndex);
    stopIndex = Math.max(state.stopIndex, stopIndex);

    let sort = {
      asc_field: '',
      dsc_field: ''
    };

    if (sortBy) {
      sort[`${sortBy['sortingDirection']}_field`] = sortBy['id'];
    }
    const response = await getFolders({ ...editor.requestProps, limit, 'skipSize': skip, query: state.query, folderUid: state.folderUid, ...sort });

    const instanceItemStatusMapped = {};


    for (let i = startIndex; i <= stopIndex + 1; i++) {
      instanceItemStatusMapped[i] = 'loaded'
    }

    setState({
      ...state,
      assets: [
        ...state.assets,
        ...response.assets
      ],
      itemStatusMap: {
        ...state.itemStatusMap,
        ...instanceItemStatusMapped
      },
      startIndex,
      stopIndex
    })

  }

  const handleClick = (asset) => {
    if (asset.new) return;
    props.setFolderUid(asset.uid);
    setState(currState => ({
      ...currState,
      breadcrumb: [...currState.breadcrumb, {
        displayName: asset.name,
        action: (len = state.breadcrumb.length, uid = asset.uid) => {
          setState(state => {
            return {
              ...state,
              breadcrumb: state.breadcrumb.slice(0, len + 1),
              folderUid: uid
            }
          });
        }
      }],
      folderUid: asset.uid
    }));
  }

  const loadMoreGrid = () => {
    const skip = state.stopIndex;
    const limit = 12;
    const startIndex = state.stopIndex + 1;
    const stopIndex = startIndex + limit;
    loadMore({ skip, startIndex, limit, stopIndex });
  }


  return (
    <div style={{ fontFamily: 'Inter, sans-serif' }}>
      <AssetBreadCrumb breadcrumbs={state.breadcrumb} />
      <AssetSearch listType={state.displayType} assetsCount={state.count} setState={setState} />
      <NoAssets length={state.assets.length}>
        {
          state.displayType === 'List' ?
            <ListView setState={setState} editor={editor} folderUid={state.folderUid} loading={state.loading} state={state} handleClick={handleClick} fetchOnChange={fetchOnChange} loadMore={loadMore} /> :
            <ThumbnailView folderUid={state.folderUid} editor={editor} state={state} handleClick={handleClick} loadMoreGrid={loadMoreGrid} handleUpload={props.handleUpload} setState={setState} />
        }
      </NoAssets>
    </div>
  )
}


export default UploadImage;
